import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap'
import {
  toggleAllAssignableRoles,
  toggleAssignableGroupRoles,
  setHideSelectedRoles,
  setShowSelectedRoles,
  filterGroupRoles,
} from 'store/Group/actions'

import Search from '../../../Search'
import SelectedItems from '../../../SelectedItems'
import { setUserRoles } from 'store/Group/actions'
import { hideUserRoles } from 'store/Group/actions'
import { toggleUsersNotAssignedFromRole } from 'store/Group/actions'

const JobTitleModal = (props) => {
  const dispatch = useDispatch()
  const groups = useSelector((state) => state.groups)
  const { items } = props

  const isChecked = (props, property, value) => {
    return props[property]?.indexOf(value) !== -1
  }

  const isUserChecked = (props, property, value) => {
    return props[property]?.indexOf(value) === -1
  }

  return (
    <Modal
      className='modal-dialog-centered'
      isOpen={props.isOpen}
      size='xl'
      toggle={() => props.setJobTitleModal(!props.isOpen)}
      scrollable
    >
      <ModalHeader
        className='border-bottom pb-2'
        toggle={() => props.setJobTitleModal(false)}
      >
        <span className='text-info'>Job title</span>
      </ModalHeader>

      <ModalBody className='scrollbar d-flex' style={{ minHeight: '60vh' }}>
        <div>
          <p>All titles:</p>

          <div className='col'>
            <div className='col-3 mb-3 pl-0'>
              <SelectedItems
                items={
                  items &&
                  items.length > 0 &&
                  items
                    .filter((item) =>
                      groups.assignableTrainingRoles.includes(item.id)
                    )
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                }
                selectedItems={groups.assignableTrainingRoles}
                showSelectedItems={groups.showSelectedRoles}
                hasDisabledProperty={false}
                onChange={toggleAssignableGroupRoles}
                setShowSelectedItems={() => dispatch(setShowSelectedRoles())}
                setHideSelectedItems={() => dispatch(setHideSelectedRoles())}
                // language={props.language}
              />
            </div>

            {items && items.length && !groups.filterGroupRolesValue ? (
              <div className='custom-control custom-checkbox-info mt-4'>
                <input
                  className='custom-control-input'
                  id='allStores'
                  type='checkbox'
                  onChange={() => dispatch(toggleAllAssignableRoles())}
                  checked={items.length === groups.selectedRoles.length}
                />
                <label className='custom-control-label' htmlFor='allStores'>
                  All
                </label>
              </div>
            ) : null}
            {items &&
              items.length > 0 &&
              items
                .filter(
                  (item) =>
                    item.name
                      .toLowerCase()
                      .indexOf(groups.filterGroupRolesValue) !== -1
                )
                .map((item, index) => (
                  <div
                    key={index}
                    className='custom-control custom-checkbox-info mb-1'
                  >
                    <input
                      className='custom-control-input'
                      id={`checkbox${index}`}
                      type='checkbox'
                      onChange={() =>
                        dispatch(toggleAssignableGroupRoles(item.id))
                      }
                      checked={isChecked(
                        groups,
                        'assignableTrainingRoles',
                        item.id
                      )}
                    />
                    <label
                      className='custom-control-label'
                      htmlFor={`checkbox${index}`}
                    >
                      {item.name && item.name}
                    </label>
                    {groups.userRoleSelected === item.name ? (
                      <span
                        style={{
                          fontSize: '10px',
                          cursor: 'pointer',
                          color: 'darkred',
                        }}
                        className='hide-show-users ml-3'
                        onClick={() => dispatch(hideUserRoles())}
                      >
                        Hide Users
                      </span>
                    ) : (
                      <span
                        style={{ fontSize: '10px', cursor: 'pointer' }}
                        className='hide-show-users ml-3'
                        onClick={() => dispatch(setUserRoles(item.name))}
                      >
                        Show Users
                      </span>
                    )}
                  </div>
                ))}
          </div>
        </div>

        <div className='col-md-5 ml-auto col-12 position-sticky top-0 '>
          <Row className='justify-content-between px-2'>
            <Search
              placeholder={'Search job roles'}
              value={groups.filterGroupRolesValue}
              onChange={(e) => dispatch(filterGroupRoles(e.target.value))}
            />
          </Row>
          {groups.userRoleSelected && groups.userRoleSelected.length > 0 && (
            <>
              <div className='row'>
                <div className='col-12'>
                  <div className='upload-video-form-row'>
                    <label>Users with {props.userRoleSelected} role</label>
                  </div>
                </div>
                <div style={{ margin: '10px 0' }} className='col-12'>
                  <i>
                    Note: If you uncheck a user here, they will not be assigned
                    to this course group even though their role is.
                  </i>
                </div>
              </div>{' '}
              <div className='row'>
                <div className='col-12'>
                  {groups.userRoles &&
                    groups.userRoles.length > 0 &&
                    groups.userRoles.map((item, index) => (
                      <div
                        style={{ margin: '10px 0' }}
                        className='modules-options'
                        key={index}
                      >
                        <label>
                          <input
                            type='checkbox'
                            onChange={() =>
                              dispatch(toggleUsersNotAssignedFromRole(item.id))
                            }
                            checked={isUserChecked(
                              groups,
                              'setUserNotAssignedFromRole',
                              item.id
                            )}
                          />
                          <span>{item.first_name}</span>{' '}
                          <span>{item.last_name}</span>
                        </label>
                      </div>
                    ))}{' '}
                </div>
              </div>
            </>
          )}
        </div>
      </ModalBody>

      <ModalFooter className='border-top py-2'>
        <Button
          className='ml-auto'
          color='link'
          data-dismiss='modal'
          type='button'
          onClick={() => props.setJobTitleModal(false)}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default JobTitleModal
